import {react} from 'react';

const Dump = (params) => {

    return (process.env.REACT_APP_DUMP_ENABLED === 'true') && <div> {JSON.stringify(params)}</div>
}

export default Dump;